__turbopack_context__.v({
  "only-desktop-no-block": "styles-module-scss-module__dkEEbG__only-desktop-no-block",
  "only-desktop-noTablet": "styles-module-scss-module__dkEEbG__only-desktop-noTablet",
  "section-tutorial": "styles-module-scss-module__dkEEbG__section-tutorial",
  "tutorial": "styles-module-scss-module__dkEEbG__tutorial",
  "tutorial__item": "styles-module-scss-module__dkEEbG__tutorial__item",
  "tutorial__item_icon": "styles-module-scss-module__dkEEbG__tutorial__item_icon",
  "tutorial__item_text": "styles-module-scss-module__dkEEbG__tutorial__item_text",
  "tutorial__item_text_steps": "styles-module-scss-module__dkEEbG__tutorial__item_text_steps",
  "tutorial__item_text_steps_info": "styles-module-scss-module__dkEEbG__tutorial__item_text_steps_info",
  "tutorial__step-item": "styles-module-scss-module__dkEEbG__tutorial__step-item",
});
